import { type ValueProps } from './TextInput.types';

export const normalizeInputTextValueProps = <TProps extends ValueProps>(props: TProps) => {
  const { value, defaultValue, ...restProps } = props;

  if (value !== undefined) {
    return { ...restProps, value };
  }

  if (defaultValue !== undefined) {
    return { ...restProps, defaultValue };
  }

  return restProps;
};
